import React from "react";
import "./DefaultLayout.scss";

/**
 * Created by vntopmas@gmail.com
 * Email: vntopmas@gmail.com
 **/
class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="ui-default-layout">
        {this.props.children}
      </div>
    );
  }
}

export default DefaultLayout;
